import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOut from "./sections/ReachOut";
import PartnerWithUs from "./sections/PartnerWithUs";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOut />
      <PartnerWithUs />
      <Footer />
    </div>;
}